// Modifica option-menu.constant.js
import { Link } from 'react-router-dom';
import { MENU_LABEL } from './menu-label.constant';
import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';

const isAdmin = JSON.parse(localStorage.getItem("userInfo"))?.admin;


export const getOptionMenu = (clearToken) => [
	{
		key: 'profile-user',
		label: (
			<Link
				to={isAdmin ? '/v2/admin-user-management?tab=1' : '/v2/user-management?tab=1'}
			>
				{MENU_LABEL.PROFILE['profile-user']}
			</Link>
		),
	},
	{
		key: 'profile-logout',
		label: (
			<Link
				to={'/login'}
				onClick={() => {
					localStorage.removeItem(LOCAL_STORAGE.USER);
					localStorage.removeItem('log');
					sessionStorage.removeItem('landing-storage');
					sessionStorage.removeItem('pharmacy-storage');
					sessionStorage.removeItem('search-list-storage');
					if (clearToken) clearToken();
				}}
			>
				{MENU_LABEL.PROFILE['profile-logout']}
			</Link>
		),
	},
];

// export const OPTION_MENU = [
// 	{
// 		key: 'profile-user',
// 		label: <Link to={'/profile-user'}>{MENU_LABEL.PROFILE['profile-user']}</Link>,
// 	},
// 	{
// 		key: 'profile-logout',
// 		label: (
// 			<Link
// 				to={'/login'}
// 				onClick={() => {
// 					localStorage.removeItem(LOCAL_STORAGE.USER);
// 					localStorage.removeItem('log');
// 					sessionStorage.removeItem('landing-storage');
// 					sessionStorage.removeItem('pharmacy-storage');
// 					sessionStorage.removeItem('search-list-storage');
// 				}}
// 			>
// 				{MENU_LABEL.PROFILE['profile-logout']}
// 			</Link>
// 		),
// 	},
// ];
